import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import LinkIcon from "@mui/icons-material/Link";

const ViewShowButton = ({ show, onShowCopyToast }) => {
  if (!show || show.publicUrl == null) {
    return null;
  }

  const { publicUrl } = show;

  return (
    <>
      <Tooltip title="View public show page">
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            window.open(publicUrl, "_blank", "noreferrer");
          }}
        >
          <LaunchIcon color="primary" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Copy public URL">
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            navigator.clipboard.writeText(publicUrl);
            onShowCopyToast();
          }}
        >
          <LinkIcon color="primary" />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default ViewShowButton;
